import api from "./api";
import { Exercise } from "../types";

async function list_all(
  professional_id: string,
  page = 1,
  per_page = 10,
  busca = "",
  only_mine = false
): Promise<Exercise[]> {
  try {
    const onlyMineParam = only_mine ? "&only_mine=true" : "";
    const { data } = await api.get(
      `/exercicies/${professional_id}/?page=${page}&per_page=${per_page}&search=${busca}${onlyMineParam}`
    );
    return data;
  } catch (e) {
    return [];
  }
}

async function update(
  exercicie_id: string,
  body: Partial<Exercise>
): Promise<{ ok: boolean; error?: string }> {
  try {
    const payload = {
      name: body.name ?? "",
      description: body.description ?? "",
      image: body.image ?? "",
      video: body.video ?? "",
    };
    await api.put(`/exercicies/${exercicie_id}/`, payload);
    return { ok: true };
  } catch (e: unknown) {
    const message =
      (e as { response?: { data?: { error?: string } } })?.response?.data
        ?.error ?? "Erro ao atualizar o exercício.";
    return { ok: false, error: message };
  }
}

async function create(
  body: Omit<Exercise, "id" | "_id">
): Promise<{ ok: boolean; error?: string }> {
  try {
    const payload = {
      professional_id: body.professional_id,
      name: body.name ?? "",
      description: body.description ?? "",
      image: body.image ?? "",
      video: body.video ?? "",
    };
    await api.post(`/exercicies/`, payload);
    return { ok: true };
  } catch (e: unknown) {
    const message =
      (e as { response?: { data?: { error?: string } } })?.response?.data
        ?.error ?? "Erro ao criar o exercício.";
    return { ok: false, error: message };
  }
}

async function deleteItem(id: string) {
  try {
    await api.delete(`/exercicies/${id}/`);
    return true;
  } catch (e) {
    return false;
  }
}

const exercicies = { list_all, update, create, deleteItem };

export default exercicies;
